import { render, staticRenderFns } from "./RunJavaScript.vue?vue&type=template&id=f5c783ac&scoped=true"
import script from "./RunJavaScript.vue?vue&type=script&lang=js"
export * from "./RunJavaScript.vue?vue&type=script&lang=js"
import style0 from "./RunJavaScript.vue?vue&type=style&index=0&id=f5c783ac&prod&lang=scss&scoped=true"
import style1 from "./RunJavaScript.vue?vue&type=style&index=1&id=f5c783ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c783ac",
  null
  
)

export default component.exports